import { useFlags } from 'launchdarkly-react-client-sdk';
import Config from 'config';

export const useCartLoggerEnabled = () => {
  const { reactBugFender } = useFlags();
  return reactBugFender && Config.env !== 'development';
};
